import { axios } from '@/utils/request'

const api = {
  entUser: '/system/user'
}

export function enterpriseUserList (parameter) {
  return axios({
    url: api.entUser + '/enterpriseUserList',
    method: 'get',
    params: parameter
  })
}